module.exports = __webpack_public_path__ + "static/media/excel-user.886f9aa6.png";